import { render, staticRenderFns } from "./IndexBanner.vue?vue&type=template&id=1673944a&scoped=true&"
import script from "./IndexBanner.vue?vue&type=script&lang=js&"
export * from "./IndexBanner.vue?vue&type=script&lang=js&"
import style0 from "./IndexBanner.vue?vue&type=style&index=0&id=1673944a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1673944a",
  null
  
)

export default component.exports